import { RunningExperiments, useExperiments } from 'state/experiments';

enum EnableRedeemInRestaurantForUnauthenticatedExperimentVariants {
  Treatment = 'treatment',
}

export const useEnableRedeemInRestaurantForUnauthenticatedExperiment = () => {
  const { variant } = useExperiments();

  return variant(
    RunningExperiments.EnableRedeemInRestaurantForUnauthenticatedExperiment,
    EnableRedeemInRestaurantForUnauthenticatedExperimentVariants.Treatment
  );
};
